export default __webpack_public_path__ + "static/media/unlock.e9ba3b1b.svg";